import { Grid, Paper } from '@mui/material';
import * as React from 'react';
import * as Redux from 'react-redux';
import BotonNuevoComponent from '../entidades/components/BotonNuevo';
import { checkModuleAccess } from '../modulos/modules.helpers';
import {
  getAllMorosidadAction,
  setActivoMorosidadAction,
} from './MorosidadAction';
import FormMorosidad from './components/FormMorosidad';
import ListadoMorosidad from './components/ListadoMorosidad';

const MorosidadView = () => {
  const dispatch = Redux.useDispatch();
  const morosidadStore = Redux.useSelector((state) => state.morosidad);
  const loginStore = Redux.useSelector((state) => state.login);

  const accessName = 'banks';
  if (!checkModuleAccess(accessName, loginStore)) {
    window.location.href = '/dashboard';
  }

  return (
    <Grid container spacing={1}>
      <Grid item md={12}>
        <BotonNuevoComponent
          click={async () => {
            await setActivoMorosidadAction(dispatch, null);
          }}
          azul
          mr={2}
        />
        {morosidadStore.all.length > 0 && (
          <BotonNuevoComponent
            click={async () => {
              await setActivoMorosidadAction(dispatch, null);
              await getAllMorosidadAction(dispatch, morosidadStore.params);
            }}
            white
            disabled={morosidadStore.loadingGetAll}
            text={
              morosidadStore.loadingGetAll ? 'Actualizando...' : 'Actualizar'
            }
          />
        )}
      </Grid>
      <Grid item md={4}>
        <Paper elevation={4}>
          <FormMorosidad />
        </Paper>
      </Grid>
      <Grid item md={8}>
        <ListadoMorosidad />
      </Grid>
    </Grid>
  );
};

export default MorosidadView;

export const mesesArray = [
  { nombre: 'Enero', valor: '01' },
  { nombre: 'Febrero', valor: '02' },
  { nombre: 'Marzo', valor: '03' },
  { nombre: 'Abril', valor: '04' },
  { nombre: 'Mayo', valor: '05' },
  { nombre: 'Junio', valor: '06' },
  { nombre: 'Julio', valor: '07' },
  { nombre: 'Agosto', valor: '08' },
  { nombre: 'Septiembre', valor: '09' },
  { nombre: 'Octubre', valor: '10' },
  { nombre: 'Noviembre', valor: '11' },
  { nombre: 'Diciembre', valor: '12' },
];
